export default __webpack_public_path__ + "img/c4ccf2d74049456eaa234878dcd66031.png";